// Import packages
import React from "react";
import {Route, Switch} from "react-router-dom";
import Layout from "../containers/Layout";

// Import utils

// Import pages
import Homepage from "../containers/homepage/Homepage";
import Search from "../containers/search/Search";
import Blog from "../containers/blog/Blog";
import BlogDetail from "../containers/blog/blogDetail/BlogDetail";
import Contacts from "../containers/contact/Contacts";
import About from "../containers/about/About";



export default function RoutesBlocks() {
    return <Layout>
        <Switch>
            <Route exact path="/" component={Homepage} />
            <Route path="/search" component={Search}/>
            <Route path="/event" component={Blog}/>
            <Route path="/travel" component={Blog}/>
            <Route path="/video" component={Blog}/>
            <Route path="/project" component={Blog}/>
            <Route path="/news/:slug" component={BlogDetail}/>
            <Route path="/contact" component={Contacts}/>
            <Route path="/about" component={About}/>
        </Switch>
    </Layout>
}


